import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { 
  Table, 
  Button, 
  Modal, 
  Form, 
  Input, 
  Select, 
  Space, 
  Popconfirm,
  message,
  Card,
  Row,
  Col,
  Typography,
  Tooltip,
  Tag
} from 'antd';
import { 
  PlusOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  SettingOutlined,
  TeamOutlined,
  UserOutlined
} from '@ant-design/icons';
import Api from "../../../../services/api";

const { Title } = Typography;
const { Option } = Select;

function Role() {
  const [data, setData] = useState([]);
  const [role, setRole] = useState({});
  const [studios, setStudios] = useState([]);
  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleChangePage = (page) => {
    setPage(page);
  }

  const getData = () => {
    setLoading(true);
    Api.get(`/api/role?page=${page}`)
      .then(result => {
        if (result?.data?.data.length > 0) {
          setData(result.data);
        }
        setLoading(false)
      });
  }

  const handleStudioData = () => {
    Api.get(`/api/studios`)
      .then(result => {
        if (result?.data?.code == 0) {
          let data = [{
            code: null,
            name: "Chọn studio"
          }];
          result.data.data.map(i => {
            data.push({
              code: i.id,
              name: i.name,
            })
          });
          setStudios(data);
        }
        setLoading(false)
      });
  }

  const handleEditRole = (item) => {
    setRole({
      id: item.id,
      name: item.name,
      code: item.code,
      studio_id: item.studio_id,
    });
    form.setFieldsValue({
      name: item.name,
      code: item.code,
      studio_id: item.studio_id,
    });
    setModal(true);
  }

  const saveData = () => {
    form.validateFields().then(values => {
      setLoading(true);
      const api = role?.id ? Api.put(`/api/role/${role.id}`, {
        name: values.name,
        code: values.code,
        studio_id: values.studio_id,
      }) : Api.post(`/api/role`, {
        name: values.name,
        code: values.code,
        studio_id: values.studio_id,
      })
      
      api.then(result => {
        setLoading(false)
        if (result.data.code == 0) {
          message.success(role?.id ? 'Cập nhật role thành công!' : 'Tạo role thành công!');
          getData()
          setRole({})
          setModal(false)
          form.resetFields();
        } else {
          message.error('Có lỗi xảy ra!');
        }
      }).catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
    });
  }

  const handleDelete = (item) => {
    setLoading(true);
    Api.delete(`/api/role/${item.id}`)
      .then(result => {
        setLoading(false);
        if (result.data.code == 0) {
          message.success('Xóa role thành công!');
          getData()
        } else {
          message.error('Có lỗi xảy ra!');
        }
      }).catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
  }

  const columns = [
    {
      title: 'Tên Role',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <Space>
          <UserOutlined style={{ color: '#1890ff' }} />
          <span style={{ fontWeight: 'bold' }}>{text}</span>
        </Space>
      ),
    },
    {
      title: 'Studio',
      dataIndex: ['studio', 'name'],
      key: 'studio',
      render: (text, record) => (
        <Space>
          <TeamOutlined style={{ color: '#52c41a' }} />
          <span>{text || 'Global'}</span>
        </Space>
      ),
    },
    {
      title: 'Hành động',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Phân quyền">
            <Link to={`/setting/roles/${record.id}/permissions`}>
              <Button 
                type="primary" 
                icon={<SettingOutlined />} 
                size="small"
              />
            </Link>
          </Tooltip>
          <Tooltip title="Chỉnh sửa">
            <Button 
              type="default" 
              icon={<EditOutlined />} 
              size="small"
              onClick={() => handleEditRole(record)}
            />
          </Tooltip>
          <Tooltip title="Xóa">
            <Popconfirm
              title="Bạn có chắc chắn muốn xóa role này?"
              description="Tất cả user có role này sẽ bị ảnh hưởng."
              onConfirm={() => handleDelete(record)}
              okText="Có"
              cancelText="Không"
            >
              <Button 
                type="primary" 
                danger 
                icon={<DeleteOutlined />} 
                size="small"
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getData();
    handleStudioData();
  }, [page]);

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <Card>
              <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
                <Col>
                  <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
                    Quản lý Role
                  </Title>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setRole({});
                      form.resetFields();
                      setModal(true);
                    }}
                    size="small"
                  >
                    Tạo Role
                  </Button>
                </Col>
              </Row>

              <Table
                columns={columns}
                dataSource={data.data || []}
                rowKey="id"
                loading={loading}
                bordered
                pagination={{
                  current: page,
                  total: data.total || 0,
                  pageSize: data.per_page || 10,
                  onChange: handleChangePage,
                  showSizeChanger: false,
                  showQuickJumper: false,
                  showTotal: (total, range) => 
                    `${range[0]}-${range[1]} của ${total} role`,
                }}
                scroll={{ x: 600 }}
              />
            </Card>
          </div>
        </section>
      </div>

      <Modal
        title={role?.id ? 'Chỉnh sửa Role' : 'Tạo Role mới'}
        open={modal}
        onCancel={() => {
          setModal(false);
          form.resetFields();
        }}
        onOk={saveData}
        confirmLoading={loading}
        width={500}
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="Tên Role"
            name="name"
            rules={[{ required: true, message: 'Vui lòng nhập tên role!' }]}
          >
            <Input placeholder="Nhập tên role" />
          </Form.Item>
          
          <Form.Item
            label="Code"
            name="code"
          >
            <Input placeholder="Nhập code role (ví dụ: admin)" />
          </Form.Item>
          
          <Form.Item
            label="Studio"
            name="studio_id"
          >
            <Select placeholder="Chọn studio">
              {studios.map(studio => (
                <Option key={studio.code} value={studio.code}>
                  {studio.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default Role;